import Button from 'react-bootstrap/Button';
import { useTimer } from 'react-timer-hook';
import { requestPreAuthenticateParticipant } from 'api/account';
import { useBearerTokenContext, useTenantContext, usePublicURLContext, useReturnURLContext } from 'utilities/contexts';

export default function CompletedAccount () {

    const bearer = useBearerTokenContext();
    const tenant = useTenantContext();
    const publicURL = usePublicURLContext();
    const returnURL = useReturnURLContext();

    // For Congrats Countdown
    const handleSuccessfulExit = () => {

        const failureMessage = "?InfoAlert=An error occured.  You may not be logged in.";

        // Pause timer if function called through button event
        // as redirect may not complete prior to countdown event.
        if (congratsTimer.isRunning)
            congratsTimer.pause();

        requestPreAuthenticateParticipant(bearer, tenant).then(
            (value) => {
                if (value === true) {
                    window.location = `${publicURL}/account/combinedjoincomplete?returnurl=${encodeURIComponent(exitURL)}`;
                } else {
                    console.log(value);
                    if (returnURL)
                        window.location = `${publicURL}/account/combinedjoincomplete?returnurl=${encodeURIComponent(exitURL)}`;
                    else {
                        exitURL += failureMessage;
                        window.location = `${publicURL}/account/combinedjoincomplete?returnurl=${encodeURIComponent(exitURL)}`;
                    }
                }
            },
            (reason) => {
                if (reason?.ApplicationExceptions)
                    reason.ApplicationExceptions.forEach((ex) => console.log(ex));
                else
                    console.log(reason);

                if (returnURL)
                    window.location = `${publicURL}/account/combinedjoincomplete?returnurl=${encodeURIComponent(exitURL)}`;
                else {
                    exitURL += failureMessage;
                    window.location = `${publicURL}/account/combinedjoincomplete?returnurl=${encodeURIComponent(exitURL)}`;
                }
            });
    }

    const expireTime = new Date();
    expireTime.setSeconds(expireTime.getSeconds() + 10);
    const congratsTimer = useTimer({ expiryTimestamp: expireTime, autoStart: true, onExpire: handleSuccessfulExit });

    // content
    let exitURL = returnURL ? returnURL : `/${tenant}/studyarms/publicsearch`;
    let completedAccountMessage = returnURL ?
        <>
                <div className='d-flex justify-content-center text-center  mb-2'>Continue on to the study that interested you!</div>
                <div className='d-flex justify-content-center text-center  mb-2' style={{ fontWeight: "500" }}>You will be redirected to in:</div>
        </>
        :
        <>
            <div className='d-flex justify-content-center text-center mb-2'>You can now start searching studies that interest you!</div>
            <div className='d-flex justify-content-center text-center mb-2' style={{ fontWeight: "500" }}>You will be redirected to study search in:</div>
        </>;
    let completeButtonLabel = returnURL ? 'Go to Study' : 'Search Studies';

    return (
        <>
            <div className='d-flex justify-content-center'>
                <img src={`${process.env.REACT_APP_API_ROOT_URL}/images/ionic_checkbox_outline.svg`} alt="" style={{ width: "110px" }} />
            </div>
            <div className='d-flex justify-content-center'><h2 className='my-2 mt-sm-5 mb-sm-4 text-center'>Congratulations! Your account has been verified.</h2>
            </div>

            {completedAccountMessage}

            <div className='d-flex justify-content-center my-sm-5'>
                <div style={{ fontSize: "20px", lineHeight: "20px" }}>{congratsTimer.seconds} seconds</div>
            </div>
            <hr />

            <br />

            <div className="d-flex justify-content-center">
                <Button variant="primary" className="ppm-button-primary" type="button" onClick={handleSuccessfulExit}>{completeButtonLabel}</Button>
            </div>
        </>
    );
}